import { HorseItem } from "GameObjects/StoryGame/ch5/HorseItem";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { floatBetween } from "html-living-framework/lib/Utils/Random";

export class Apple extends HorseItem {

    dragEnd() {
        super.dragEnd();
        this.sprite.y = 0;
    }

    dragBegin() {
        super.dragBegin();
        this.sprite.y = -100;
    }

    public Eat(pProgress: 0 | 0.5 | 1) {
        let newTexture: string;
        switch (pProgress) {
            case 0:
                newTexture = "apple_whole";
                break;
            case 0.5:
                newTexture = "apple_part_eaten";
                break;
            case 1:
                newTexture = "apple_eaten";
                break;
        }
        this.setLayoutTexture(newTexture, 0.5, 0.5);
    }

    onLayout() {
        this.scale.set(Math.max(this.scale.x, this.scale.y));
        this.Eat(0);
    }
}
